module.exports = __webpack_public_path__ + "static/media/gallery_03_t.3be43a70.jpg";